import React from 'react';

export default function DefaultTabTextLogo({ label }) {
  return (
    <div id="logo">
      <div id="logo-default">
        {label}
      </div>
    </div>
  )
}
